export enum ErrorCodes {
  AuthorizationError = 1400,
  GenericError = 2000,
}
